/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Timing_Settings_UpdatedInputs */



/**
* | output |
* | --- |
* | "Project timing settings updated." |
*
* @param {Project_Timing_Settings_UpdatedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const project_timing_settings_updated = /** @type {((inputs?: Project_Timing_Settings_UpdatedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Timing_Settings_UpdatedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Paramètres de minutage du projet mis à jour.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Projektzeiteinstellungen wurden aktualisiert.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impostazioni di temporizzazione del progetto aggiornate.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обновлены настройки сроков выполнения проекта.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se actualizaron las configuraciones de tiempo del proyecto.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目时间设置已更新。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトのタイミング設定が更新されました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट के समय निर्धारण संबंधी सेटिंग्स अपडेट कर दी गई हैं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configurações de tempo do projeto atualizadas.")
	return /** @type {LocalizedString} */ ("Project timing settings updated.")
});